import controller from '../../Controller.js';
import { Announcer } from '../../Helpers/Announcer.js';
import { CoursesStatusUpdater } from '../../Helpers/CoursesStatusUpdater.js';

function Paging(button) {
    var resultContainer;
    var totalCount;

    function init() {
        var resultContainerId = button.getAttribute('data-paging-for');
        button.addEventListener('click', handlePaging);
        button.setAttribute('aria-controls', resultContainerId);
        resultContainer = document.getElementById(resultContainerId);
        totalCount = parseInt(resultContainer.getAttribute('data-total-count'));
        window.addEventListener('FilterUpdate', () => {
            button.classList.add('hidden');
        });
        window.addEventListener('ResultUpdated', handleResultUpdated);
    }

    function handleResultUpdated() {
        resultContainer = document.getElementById(button.getAttribute('data-paging-for'));
        totalCount = parseInt(resultContainer.getAttribute('data-total-count'));

        // Update totalCount for screen readers
        if (totalCount === 0) {
            Announcer(resultContainer.dataset.nohits);
        } else {
            Announcer(totalCount + ' ' + resultContainer.dataset.hits);
        }

        if (resultContainer.querySelectorAll('.card:not(.card--placeholder), .list__item').length >= totalCount) {
            button.classList.add('hidden');
        } else {
            button.classList.remove('hidden');
        }
    }

    function handlePaging(e) {
        e.preventDefault();
        button.setAttribute('data-loading', 'true');

        var searchParams = new URLSearchParams(location.search);
        var page = searchParams.get('p') || 0;
        searchParams.set('p', parseInt(page) + 1);
        history.replaceState(null, null, '?' + searchParams.toString());

        fetchItems(searchParams, function (html) {
            appendNewItems(html);
            CoursesStatusUpdater();
        });

    }


    function fetchItems(searchParams, callback) {
        var request = new XMLHttpRequest();
        var url = button.getAttribute('data-url') + '?' + searchParams.toString();

        request.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                console.log('Error fetching items');
                return;
            }
            callback(this.responseText);
        };

        request.open('POST', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.send();
    }

    function appendNewItems(html) {
        button.removeAttribute('data-loading');
        removePlaceholders();
        resultContainer.insertAdjacentHTML('beforeend', html);
        //TODO: Make work without specific class names. This is a workaround because result container contains other than pure items. Bad.
        var items = resultContainer.querySelectorAll('.card:not(.card--placeholder), .list__item');

        Announcer(button.dataset.feedback, true);

        setTimeout(function () {
            /*items.forEach((item) => {
              item.classList.remove('card--new');
            });
            */

            if (items.length >= totalCount) {
                button.classList.add('hidden');
            }
        }, 100);
    }

    function removePlaceholders() {
        var placeholders = resultContainer.querySelectorAll('.card--placeholder');
        placeholders.forEach((item) => {
            item.remove();
        });
    }

    return {
        init: init
    }
}

controller.add('Paging', Paging);

export default Paging;
